/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Priority/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Priority({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/ActivityType/Log/FromPart/Priority",
  value
  
}) {
let constantData = 'from'
let constantData1 = '‎'
let aggregateData = fromAggregate.join(constantData, constantData1)
let activityTextpartsFromValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.from',
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsBlue200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.200'
        })
let dtColorsYellow200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.yellow.200'
        })
let dtColorsRed200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.200'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtTypographyFontsizeMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.ms'
        })
let dtColorsBlue900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.900'
        })
let dtColorsYellow900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.yellow.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Priority.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={activityTextpartsFromValueData}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 fontSize={dtTypographyFontsizeM}
 data="'from'"
 data="'‎'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 data="activity.textParts.from"
/>
</fromFlow.When>
<div
  data-testid="Priority.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mr-1-Z1iuO0B': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pl-3-Z1iuO0B': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pr-4-Z1iuO0B': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bblr-5-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-6-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btlr-7-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-8-Z1iuO0B': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-9-Z1iuO0B': value === 'low' ? dtColorsNeutral200 : value === 'medium' ? dtColorsBlue200 : value === 'high' ? dtColorsYellow200 : value === 'urgent' ? dtColorsRed200 : "transparent"}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 color={value === 'medium' ? dtColorsBlue900 : value === 'high' ? dtColorsYellow900 : value === 'urgent' ? dtColorsRed900 : dtColorsNeutral900}
 size="tiny"
 weight="medium"
 textTransform="capitalize"
 text={value}
 fontSize={dtTypographyFontsizeMs}
/>
</div>
</div>
{children}
</React.Fragment>)
}